<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button title="back page" (click)="backToExit()" >
                                      <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Employee Acknowledge </h3>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header">
                        <div class="title col-sm-12 d-flex">
                            <h3><a (click)="openExitForm()" class="cursor-pointer">User</a></h3>
                            <h3><a (click)="openDepartmentExit()" class="cursor-pointer">Department</a></h3>
                            <h3><a (click)="openItHrmExit()" class="cursor-pointer">IT</a></h3>
                            <h3><a (click)="openFinanceExit()" class="cursor-pointer">Finance</a></h3>
                            <h3><a (click)="openHrExit()" class="cursor-pointer">HR & Admin</a></h3>
                            <h3><a class="active cursor-pointer">Employee AcKnowledge</a></h3>
                        </div>
                        <!-- <div class="title col-sm-6 d-flex" *ngIf="!this.isVisible">
                            <h3><a (click)="openExitForm()" class="cursor-pointer">User</a></h3>
                            <h3><a class="active cursor-pointer">Employee Acknowledge</a></h3>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
                            <div class="canvas-data">
                                <form [formGroup]="empAckForm">
                                    <p> I, <b>{{this.employeeName}}</b> Acknowledge that i have returned all company property,completed the necessary clearance 
                                        procedures and have no outstanding dues or obligations. I also accept any recoveries or 
                                        deductions menstioned as part of clearance process.
                                    </p>   
                                    {{this.employeeName}}
                                    <br>Date: 
                                    <div class="col-sm-6">
                                        <div class="input" *ngIf="this.isDateDisabled">
                                            <div class="input-item" *ngIf="this.isHRAdmin || this.isFinanceAdmin || this.isITAdmin || this.isManager">
                                                <input type="date" formControlName="extraColumn1" disabled>
                                                <label class="floating-label-special">Acknowledgement Done on Date:</label>
                                                <i class="ri-calendar-line"></i>
                                            </div>
                                            <div class="input-item" *ngIf="(!this.isHRAdmin || !this.isFinanceAdmin || !this.isITAdmin || !this.isManager) && this.isUser">
                                                <input type="date" formControlName="extraColumn1" (change)="openModal()" data-bs-toggle="modal" data-bs-target="#confirmAck" Done>
                                                <label class="floating-label-special">Acknowledgement Done on Date:</label>
                                                <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                        <div class="input" *ngIf="!this.isDateDisabled">
                                            <div class="input-item" *ngIf="this.isHRAdmin">
                                                <input type="date" formControlName="extraColumn1" disabled>
                                                <label class="floating-label-special">Date</label>
                                                <i class="ri-calendar-line"></i>
                                            </div>
                                            <div class="input-item" *ngIf="!this.isHRAdmin">
                                                <input type="date" formControlName="extraColumn1" (change)="openModal()" data-bs-toggle="modal" data-bs-target="#confirmAck">
                                                <label class="floating-label-special">Date</label>
                                                <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </article>
</main>

<div class="modal fade" id="confirmAck" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content pl-5 pr-5">
        <form action="">
          <div class="modal-header">
            <h5 class="modal-title">Acknowledgement Confirmation</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <p>>Are you sure want to proceed with this acknowledgement?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button id="closeModalconfirmAck" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="confirmation()">Yes</button>
          </div>
        </form>
      </div>
    </div>
  </div>